import React from 'react';
import {
  Flex,
  Spinner,
  Text,
  VStack,
  useColorModeValue,
  type FlexProps,
} from '@chakra-ui/react';

interface LoadingSpinnerProps {
  label?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  minH?: FlexProps['minH'];
  align?: 'stretch' | 'center' | 'flex-start' | 'flex-end';
}

export default function LoadingSpinner({
  label,
  size = 'xl',
  minH = 'calc(100dvh - 20rem)',
  align = 'center',
}: LoadingSpinnerProps): JSX.Element {
  const secondaryTextColor = useColorModeValue('gray.600', 'gray.300');

  return (
    <Flex
      w="full"
      flex="1"
      minH={minH}
      align="center"
      justify="center"
    >
      <VStack spacing={4} align={align}>
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="green.500"
          size={size}
        />
        {label != null && label !== '' && (
          <Text color={secondaryTextColor}>{label}</Text>
        )}
      </VStack>
    </Flex>
  );
}
